/**
 * HrHeadcountPrint — l'onglet « Effectif » de Chiffres clés, en PDF.
 *
 * Il MONTE l'écran (`HrHeadcountPage` en mode embarqué) au lieu de redessiner
 * sa grille : une seconde table diverge de la première à la première colonne
 * ajoutée, et celle-ci porte douze mois par personne. Ce que l'impression
 * retire, elle le retire en CSS (la barre de filtres et les indicateurs de
 * tri, qui ne veulent rien dire sur papier).
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import HrHeadcountPage from '../HrHeadcountPage';
import PrintReportHeader from './PrintReportHeader';
import '../HrPage.css';

export default function HrHeadcountPrint({ activeTenant, year, editedAt, onDataReady }) {
  const { t } = useTranslation();
  return (
    <section className="ppl-print__section ppl-print__section--headcount">
      <PrintReportHeader category="People" title={t('print:reports.people-headcount')}
                         year={year} tenant={activeTenant} editedAt={editedAt} />
      <HrHeadcountPage embedded activeTenant={activeTenant} year={year} onDataReady={onDataReady} />
    </section>
  );
}
